<template>
    <div>
        <el-slider
            v-model="currentValue"
            :min="min"
            :max="max"
            :marks="marks"
            :showInput="showInput"
            :disabled="mode !== 'edit'"
        >
        </el-slider>
    </div>
</template>
<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        modelValue: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
            required: false,
            default: 0,
        },
        max: {
            type: Number,
            required: false,
            default: 100,
        },
        showInput: {
            type: Boolean,
            required: false,
            default: false,
        },
        marks: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    computed: {
        currentValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
</script>

<style lang="scss">
.el-slider .el-input-number {
    .el-icon-minus,
    .el-icon-plus {
        line-height: 22px;
    }
}
</style>
